// extracted by mini-css-extract-plugin
export var csatScore = "_n6-5";
export var header = "_n6-1";
export var panelWrapper = "_n6-2";
export var postPreview = "_n6-3";
export var rightContent = "_n6-0";
export var wrappingText = "_n6-4";